//////////////////  BLOQUER CLIQUE DROIT ETC.
const PROTECT_SITE = false; // ← change à false pour désactiver toute la protection

if (PROTECT_SITE) {
  // Bloquer le clic droit
  document.addEventListener("contextmenu", (e) => e.preventDefault());

  // Bloquer sélection & glisser
  document.addEventListener("selectstart", (e) => e.preventDefault());
  document.addEventListener("dragstart", (e) => e.preventDefault());

  // Bloquer raccourcis : F12, Ctrl+Shift+I/J, Ctrl+U/S
  document.addEventListener("keydown", function (e) {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
      (e.ctrlKey && (e.key === "U" || e.key === "S"))
    ) {
      e.preventDefault();
    }
  });
}

// Fonction principale d'initialisation
function initCustomScripts() {
  //////////////////  SMOOTH SCROLL
  
  document.querySelectorAll(".scroll-no-hash").forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetSelector = this.getAttribute("data-target");
      const target = document.querySelector(targetSelector);
      if (!target) return;

      const startY = window.pageYOffset;
      const endY = target.getBoundingClientRect().top + window.pageYOffset;
      const distance = endY - startY;
      const duration = 600;
      let start;

      function step(timestamp) {
        if (!start) start = timestamp;
        const time = timestamp - start;
        const percent = Math.min(time / duration, 1);
        window.scrollTo(0, startY + distance * easeInOutQuad(percent));
        if (time < duration) requestAnimationFrame(step);
      }

      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      }

      requestAnimationFrame(step);
    });
  });

  ///////////////////////// UTILISE LES ICONE FONT-AWESOME COMME CA : [fa-light fa-rotate-left]
  const replaceFA = (el) => {
    el.innerHTML = el.innerHTML.replace(
      /\[(fa-(solid|regular|light|thin|brands|duotone) fa-[a-z0-9-]+)\]/gi,
      (match, classes) => {
        return `<i class="${classes}" style="margin-right: 6px; color:inherit"></i>`;
      }
    );
  };

  const targets = document.querySelectorAll(
    "[data-icon-fa], .collapsible__title, .collapsible-content, h1, h2, h3, p, span, li"
  );

  targets.forEach(replaceFA);

  //////////////////  FORCER COULEUR SWIPER PAGINATION BULLETS
  // Force la couleur des bullets de pagination Swiper
  function forceSwiperBulletColor() {
    const bullets = document.querySelectorAll(".swiper-pagination-bullet");
    bullets.forEach((bullet) => {
      bullet.style.setProperty(
        "background-color",
        "rgba(90, 90, 90, 0.5)",
        "important"
      );
    });
  }

  forceSwiperBulletColor();
  document.addEventListener("shopify:section:load", forceSwiperBulletColor);

  // Observer les nouveaux bullets ajoutés
  const swiperObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            const newBullets = node.querySelectorAll
              ? node.querySelectorAll(".swiper-pagination-bullet")
              : [];
            newBullets.forEach((bullet) => {
              bullet.style.setProperty(
                "background-color",
                "rgba(90, 90, 90, 0.5)",
                "important"
              );
            });
          }
        });
      }
    });
  });

  swiperObserver.observe(document.body, { childList: true, subtree: true });

  // CHECKOUT SHIPPING NOTE
  const shippingTitle = document.querySelector(
    '[data-step="shipping_method"] h2'
  );
  if (shippingTitle && !document.querySelector("#custom-shipping-note")) {
    const note = document.createElement("p");
    note.id = "custom-shipping-note";
    note.textContent =
      "💡 Vous pourrez choisir votre locker sur la page suivante.";
    note.style.fontSize = "14px";
    note.style.color = "#666";
    note.style.marginTop = "6px";
    shippingTitle.insertAdjacentElement("afterend", note);
  }

  //////////////////  DÉSACTIVATION DU ZOOM SUR CAROUSEL PRODUIT

  // Supprime l'attribut data-zoom-on-hover qui active le zoom
  const productInfo = document.querySelector("product-info");
  if (productInfo) {
    productInfo.removeAttribute("data-zoom-on-hover");
  }

  // Empêche le chargement du script magnify.js
  const magnifyScript = document.querySelector(
    'script[src*="magnify.js"], #EnableZoomOnHover-main'
  );
  if (magnifyScript) {
    magnifyScript.remove();
  }

  // Désactive tous les événements de clic sur les modal-opener
  const modalOpeners = document.querySelectorAll(".product__modal-opener");
  modalOpeners.forEach((opener) => {
    opener.style.pointerEvents = "none";
    opener.style.cursor = "default";

    // Supprime tous les event listeners existants en clonant l'élément
    const clone = opener.cloneNode(true);
    opener.parentNode.replaceChild(clone, opener);
  });

  // Supprime la classe image-magnify-hover
  const magnifyImages = document.querySelectorAll(".image-magnify-hover");
  magnifyImages.forEach((img) => {
    img.classList.remove("image-magnify-hover");
    img.style.cursor = "default";
  });

  //////////////////  AMÉLIORATION SCROLL CAROUSEL PRODUIT
  // Le carousel permet le scroll horizontal ET vertical (vertical = scroll de la page)

  // Sélectionne tous les carousels (sliders)
  const sliders = document.querySelectorAll(
    ".slider--mobile, .slider--tablet, .slider--tablet-up, .slider--desktop, .slider--everywhere, .product__media-list"
  );

  sliders.forEach((slider) => {
    // Empêche le carousel de capturer le focus du scroll
    // Le scroll vertical passera naturellement à la page parent
    slider.style.overflowY = "hidden";
  });
}

// Initialiser au chargement de la page (ou immédiatement si déjà chargé)
if (document.readyState === "loading") {
  // DOM pas encore chargé, attendre l'événement
  document.addEventListener("DOMContentLoaded", initCustomScripts);
} else {
  // DOM déjà chargé (cas des scripts defer), initialiser tout de suite
  initCustomScripts();
}
